<template>
  <dl class="row mt-3">
    <dt class="col-auto">
      <img src="@/assets/logos/openapi-logo.png" alt="NIDD API" width="75">
    </dt>
    <dd class="col-auto">
      <a :href="niddApiSwaggerUrl" target="_blank">
        <span class="fw-bold">Non-IP Data Delivery (NIDD)</span>
      </a>
    </dd>
    <dt class="col-auto">
      <img src="@/assets/logos/python-logo.png" alt="Modem Abstraction" width="95">
    </dt>
    <dd class="col-auto">
      <a v-tooltip
        href="https://github.com/inmarsat-enterprise/pynbntnmodem"
        target="_blank"
        title="Open-source Python project abstracting AT commands to interface to any module."
      >      
        pynbntnmodem
      </a>
    </dd>
    <dt class="col-auto">
      <span v-tooltip
        data-bs-html="true"
        title="Requires <i>collaborator</i> access and Quectel NDA."
        class="cursor-help"
      >
        <img src="@/assets/logos/quectel-logo.png" alt="Quectel Modules" width="95">  
      </span>
    </dt>
    <dd class="col-auto text-start">
      <ul>
        <li>
          <a href="https://github.com/inmarsat-enterprise/pynbntnmodem-quectel-cc660d" target="_blank">
            CC660D-LS (satellite only)
          </a>
        </li>
        <li>
          <a href="https://github.com/inmarsat-enterprise/pynbntnmodem-quectel-bg95s5" target="_blank">
            BG95-S5 (hybrid)
          </a>
        </li>
        <li>
          <a href="https://github.com/inmarsat-enterprise/pynbntnmodem-quectel-bg770asn" target="_blank">
            BG770A-SN (hybrid)
          </a>
        </li>
      </ul>
    </dd>
    <dt class="col-auto">
      <span v-tooltip
        data-bs-html="true"
        title="Requires <i>collaborator</i> access and Murata NDA."
        class="cursor-help"
      >
        <img src="@/assets/logos/murata-logo.png" alt="Murata Modules" width="95">  
      </span>
    </dt>
    <dd class="col-auto text-start">
      <ul>
        <li>
          <a href="https://github.com/inmarsat-enterprise/pynbntnmodem-murata-type1sc" target="_blank">
            Type 1SC (hybrid)
          </a>
        </li>
      </ul>
    </dd>
    <dt class="col-auto">
      <span v-tooltip
        data-bs-html="true"
        title="Requires <i>collaborator</i> access and Semtech NDA."
        class="cursor-help"
      >
        <img src="@/assets/logos/semtech-logo.png" alt="Semtech Modules" width="95">  
      </span>
    </dt>
    <dd class="col-auto text-start">
      <ul>
        <li>
          <a href="https://github.com/inmarsat-enterprise/pynbntnmodem-semtech-hl781x" target="_blank">
            HL781x (hybrid)
          </a>
        </li>
      </ul>
    </dd>
  </dl>
</template>

<script setup>
import { useAuthStore } from '@/stores/authStore';
import { niddApiSwaggerUrl } from '@/utils/config';

const auth = useAuthStore();

</script>

<style scoped>
.row {
  /* Prevents breaking in the middle of a word */
  word-break: keep-all; 
  /* Ensures overflow text wraps at whitespace only */
  overflow-wrap: break-word; 
}

/* Optional: Prevent your long GitHub links from stretching the layout */
a {
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis; /* Adds '...' if the link is way too long */
  vertical-align: bottom;
}

ul {
  /* Forces bullets to stay outside the text flow */
  list-style-position: outside; 
  /* Standard Bootstrap padding to make room for the bullet */
  padding-left: 1.5rem; 
}

li {
  /* Ensure the list item isn't using flex, which can mess with bullet alignment */
  display: list-item;
  margin-bottom: 0.25rem;
}

li a {
  /* Links should be inline or inline-block so they don't break the bullet logic */
  display: inline;
}

dl {
  display: grid;
  grid-template-columns: max-content 1fr; /* Label width vs. Content width */
  align-items: center;                   /* This centers the DT to the Image in the DD */
  column-gap: 1rem;
  row-gap: 0.5rem;
}

dt {
  margin: 0;
  justify-content: center;
}
</style>